import { GetAddressesResponse } from "@/models/api.models";

export interface PoolMarker {
  latitude: number;
  longitude: number;
  icon: string;
  poolName: string;
  message: string;
  zIndex: number;
}

/**
 * Taken from v1 codebase
 * main.js loadAddresses (line 9873)
 */

function isOldDate(adate: number, age: number) {
  return adate == null || adate > age;
}

export default function buildMarkers(data: GetAddressesResponse): PoolMarker[] {
  const markers = [] as PoolMarker[];
  const mapAddMarker = (
    latitude: number,
    longitude: number,
    icon: string,
    poolName: string,
    message: string,
    zIndex: number
  ) => {
    markers.push({
      latitude,
      longitude,
      icon: icon.replace(
        "img/",
        (import.meta.env.BASE_URL || "/") + "img/markers/"
      ),
      poolName,
      message,
      zIndex,
    });
  };

  data.poolLessPods.forEach((elem) => {
    if (elem.count > 1)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/radioGrey.png",
        elem.userNickname != null ? elem.userNickname : elem.username,
        elem.count + " boîtiers non associés",
        1
      );
    else
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/radioGrey.png",
        elem.userNickname != null ? elem.userNickname : elem.username,
        "1 boîtier non associé",
        2
      );
  });

  data.addressLessPools.forEach((elem) => {
    const pn = elem.poolNickname;
    if (elem.device == 255)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/construction.png",
        pn,
        "Bassin effacé ou réaffecté",
        8
      );
    else if (elem.notInstalled)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/construction.png",
        pn,
        "Bassin non installé",
        8
      );
    else if (elem.suspended == 1)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/moonstar.png",
        pn,
        "Bassin suspendu",
        8
      );
    else if (elem.hivern !== undefined)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/snowBlue.png",
        pn,
        "Bassin hiverné",
        8
      );
    else if (isOldDate(elem.lastPing, 1800))
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/noLink.png",
        pn,
        "Internet coupé, pas d'adresse!",
        8
      );
    else if (isOldDate(elem.infosTime, 7200))
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/divingGrey.png",
        pn,
        "Liaison coffret coupée, pas d'adresse!",
        8
      );
    else if (elem.alertCount > 0)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/divingRed.png",
        pn,
        elem.alertCount + elem.notifyCount + " message(s), pas d'adresse!",
        8
      );
    else if (elem.notifyCount > 0)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/divingOrange.png",
        pn,
        elem.notifyCount + " message(s), pas d'adresse!",
        9
      );
    else
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/divingGreen.png",
        pn,
        "Pas d'adresse!",
        10
      );
  });

  data.pools.forEach((elem) => {
    const pn = elem.poolNickname;
    if (elem.device == 255)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/construction.png",
        pn,
        "Bassin effacé ou réaffecté",
        8
      );
    else if (elem.notInstalled)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/construction.png",
        pn,
        "Bassin non installé",
        8
      );
    else if (elem.suspended == 1)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/moonstar.png",
        pn,
        "Bassin suspendu",
        8
      );
    else if (elem.hivern !== undefined)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/snowBlue.png",
        pn,
        "Bassin hiverné",
        8
      );
    else if (isOldDate(elem.lastPing, 1800))
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/noLink.png",
        pn,
        "Internet coupé",
        8
      );
    else if (isOldDate(elem.infosTime, 3600 * 2))
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/divingGrey.png",
        pn,
        "Liaison coffret coupée",
        8
      );
    else if (elem.alertCount > 0)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/divingRed.png",
        pn,
        elem.alertCount + elem.notifyCount + " message(s)",
        8
      );
    else if (elem.notifyCount > 0)
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/divingOrange.png",
        pn,
        elem.notifyCount + " message(s)",
        9
      );
    else
      mapAddMarker(
        elem.latitude,
        elem.longitude,
        "img/divingGreen.png",
        pn,
        "Aucun message",
        10
      );
  });

  return markers;
}
